import { useQuery } from '@tanstack/react-query';
import { FirebaseCallable, functions } from '@util/firebase';
import { httpsCallable } from 'firebase/functions';
import type { ProductDocument } from 'models/product';

export type WarehouseVariationsResponse = {
  keys: {
    key: string;
    label: string;
    values: (string | number)[];
  }[];
  options: {
    id: string;
    values: { key: string; value: string | number }[];
  }[];
  relatedItems: ProductDocument[];
};

export const useWarehouseVariations = (product: ProductDocument | null) => {
  const { data, isLoading, error } = useQuery<WarehouseVariationsResponse>({
    queryKey: ['warehouseVariations', product?.group_id],
    queryFn: async () => {
      if (!product) {
        return {
          keys: [],
          options: [],
          relatedItems: [],
        };
      }

      const { data } = await httpsCallable<
        { product: ProductDocument },
        WarehouseVariationsResponse
      >(
        functions,
        FirebaseCallable.getWarehouseVariations
      )({
        product,
      });
      return data;
    },
    enabled: !!product?.group_id,
  });

  return {
    variations: data ?? {
      keys: [],
      options: [],
      relatedItems: [],
    },
    relatedItems: data?.relatedItems ?? [],
    isLoading,
    error,
  };
};
